import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark text-light py-4 mt-auto">
      <Container>
        <Row>
          <Col md={4}>
            <h5>AutoFill</h5>
            <p>Новостной портал с персонализированной лентой на основе ваших предпочтений.</p>
          </Col>
          <Col md={2}>
            <h6>Навигация</h6>
            <ul className="list-unstyled">
              <li><Link to="/" className="text-light text-decoration-none">Главная</Link></li>
              <li><Link to="/news" className="text-light text-decoration-none">Новости</Link></li>
              <li><Link to="/profile" className="text-light text-decoration-none">Профиль</Link></li>
            </ul>
          </Col>
          <Col md={3}>
            <h6>Информация</h6>
            <ul className="list-unstyled">
              <li><Link to="/terms" className="text-light text-decoration-none">Условия использования</Link></li>
              <li><Link to="/privacy" className="text-light text-decoration-none">Политика конфиденциальности</Link></li>
              <li><Link to="/contact" className="text-light text-decoration-none">Контакты</Link></li>
            </ul>
          </Col>
          <Col md={3}>
            <h6>Контакты</h6>
            <address>
              <p>Email: info@autofill.example.com</p>
              <p>Телефон: +7 (XXX) XXX-XX-XX</p>
            </address>
          </Col>
        </Row>
        <hr className="bg-light" />
        <Row>
          <Col className="text-center">
            <p className="mb-0">&copy; {currentYear} AutoFill. Все права защищены.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
